/**
 * Validation for the email-template admin endpoints.
 *
 * v1 scope: name + body (required), optional subject for replies.
 * No variable interpolation yet — the body is inserted verbatim into
 * the composer textarea, staff edits before sending.
 */

import { z } from 'zod';

export const emailTemplateScopeSchema = z.enum(['reply', 'note']);
export type EmailTemplateScopeSchemaT = z.infer<typeof emailTemplateScopeSchema>;

export const emailTemplateCreateInputSchema = z.object({
  name: z.string().min(1).max(120),
  scope: emailTemplateScopeSchema,
  subject: z.string().max(500).nullable().optional(),
  body: z.string().min(1).max(20_000),
});
export type EmailTemplateCreateInput = z.infer<
  typeof emailTemplateCreateInputSchema
>;

export const emailTemplateUpdateInputSchema = z.object({
  name: z.string().min(1).max(120).optional(),
  scope: emailTemplateScopeSchema.optional(),
  subject: z.string().max(500).nullable().optional(),
  body: z.string().min(1).max(20_000).optional(),
});
export type EmailTemplateUpdateInput = z.infer<
  typeof emailTemplateUpdateInputSchema
>;
